import type { MouseEvent, Ref } from "react";
import { usePortal } from "./context.js";
import { Icon } from "./parts.js";
import { sheetURL } from "./paths.js";

/** The coach's sheet: beside the page in a wide window, else a new tab (and always with a modifier key). */
export function SheetLink({
  week,
  toggle,
  id,
  ref,
  labelClass,
  "aria-controls": controls,
  "aria-pressed": pressed,
}: {
  week: string;
  toggle?: boolean;
  id?: string;
  ref?: Ref<HTMLAnchorElement>;
  labelClass?: string;
  "aria-controls"?: string;
  "aria-pressed"?: "true" | "false";
}) {
  const { openSheet } = usePortal();
  const click = (event: MouseEvent) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey) return;
    if (openSheet(week, toggle)) event.preventDefault();
  };
  return (
    <a className="k-btn" id={id} ref={ref} href={sheetURL(week)} target="_blank" rel="noopener" aria-controls={controls} aria-pressed={pressed} onClick={click}>
      {Icon.sheet}
      {labelClass ? <span className={labelClass}>Coach's sheet</span> : "Coach's sheet"}
    </a>
  );
}
